import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Chip } from '../Chip/Chip';

// const LegPositionLabel = styled(Box)(({ theme }) => ({
//   padding: theme.spacing(0.25, 0.75),
//   borderRadius: '12px',
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.primary.contrastText,
//   fontSize: '0.65rem',
//   fontWeight: 600,
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   flexShrink: 0,
//   whiteSpace: 'nowrap',
// }));

const PillContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '16px', // Adjusted for smaller height
  padding: theme.spacing(0, 1.5), // Reduced padding for smaller height
  width: '360px', // Twice the NODE_WIDTH (180px × 2)
  height: '32px', // Match NODE_HEIGHT exactly
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  backdropFilter: 'blur(8px)',
  zIndex: 15,
  position: 'absolute',
  whiteSpace: 'nowrap',
  overflow: 'hidden', // Ensure text doesn't overflow
}));

const StatsText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '0.875rem', // Increased font size since we have more space
  color: theme.palette.text.secondary,
}));

// const Separator = styled('span')(({ theme }) => ({
//   margin: theme.spacing(0, 0.75),
//   color: theme.palette.divider,
//   fontWeight: 400,
// }));

export interface LegLabelProps {
  legNumber: number;
  x: number;
  y: number;
  memberCount?: number;
  partnerCount?: number;
}

// Smart comparison function for React.memo
const areLegLabelPropsEqual = (prevProps: LegLabelProps, nextProps: LegLabelProps): boolean => {
  return (
    prevProps.legNumber === nextProps.legNumber &&
    prevProps.x === nextProps.x &&
    prevProps.y === nextProps.y &&
    prevProps.memberCount === nextProps.memberCount &&
    prevProps.partnerCount === nextProps.partnerCount
  );
};

const LegLabelComponent: React.FC<LegLabelProps> = ({
  legNumber,
  x,
  y,
  memberCount,
  partnerCount,
}) => {
  // Build the stats text inline
  const statsText = [];
  if (memberCount !== undefined) {
    statsText.push(`${memberCount} Members`);
  }
  if (partnerCount !== undefined && partnerCount > 0) {
    statsText.push(`${partnerCount} Partners`);
  }

  const ariaLabel = `Leg ${legNumber} summary: ${statsText.join(', ')}`;

  return (
    <PillContainer
      role="group"
      aria-label={ariaLabel}
      style={{
        left: x,
        top: y,
      }}
    >
      <Chip
        color="unicityPurple"
        size="small"
        label={`Leg ${legNumber}`}
        style={{
          fontSize: '10px',
          fontWeight: 600,
        }}
        aria-hidden="true"
      />&nbsp;
      {statsText.length > 0 && (
        <StatsText aria-hidden="true">
          {statsText.join(' | ')}
        </StatsText>
      )}
    </PillContainer>
  );
};

// Export memoized version with custom comparison
export const LegLabel = React.memo(LegLabelComponent, areLegLabelPropsEqual); 